/**
 * ExportPdfModal — PDF export modal built on TradeModal.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/export-pdf-modal.liquid via trade-modal.liquid).
 *
 * Usage:
 *   window.exportPdfModal.open(url, { label, id, title, date, dateLabel, total })
 */
(function () {
	var overlay = document.getElementById('export-pdf-modal');
	if (!overlay) return;

	var modal = new TradeModal(overlay);

	var _url = '';
	var titleEl = overlay.querySelector('[data-modal-title]');
	var infoEl = overlay.querySelector('[data-modal-info]');
	var totalEl = overlay.querySelector('[data-modal-total]');
	function showState(state) {
		overlay.querySelectorAll('[data-state]').forEach(function (el) {
			if (el.dataset.state === state) {
				el.classList.remove('trade-modal__section--hidden');
			} else {
				el.classList.add('trade-modal__section--hidden');
			}
		});
	}

	function startDownload() {
		showState('loading');
		window.location.href = _url;

		setTimeout(function () {
			showState('success');
			modal._autoCloseTimer = setTimeout(function () {
				modal.close();
			}, 3000);
		}, 2000);
	}

	// Download button click
	overlay.addEventListener('click', function (e) {
		if (e.target.closest('[data-export-download]')) {
			startDownload();
		}
	});

	// Public API
	window.exportPdfModal = {
		open: function (url, opts) {
			_url = url;
			var label = opts.label;

			titleEl.textContent = 'EXPORT ' + label.toUpperCase();

			var infoClone = window.cloneTemplate('tpl-export-pdf-info');
			infoClone.querySelector('[data-tpl-label-id]').textContent = label.toLowerCase() + ': #' + opts.id;
			infoClone.querySelector('[data-tpl-title]').textContent = opts.title;
			infoClone.querySelector('[data-tpl-date-label]').textContent = opts.dateLabel;
			infoClone.querySelector('[data-tpl-date]').textContent = opts.date;
			infoEl.replaceChildren(infoClone);

			var totalClone = window.cloneTemplate('tpl-export-pdf-total');
			totalClone.querySelector('[data-tpl-total]').textContent = opts.total;
			totalEl.replaceChildren(totalClone);

			showState('idle');
			modal.open();
		},

		close: function () {
			modal.close();
		}
	};
})();
